"use server";

import { getCollectionProducts, getProducts } from "@/lib/shopify";
import type { ProductPage } from "@/lib/shopify/types";
import { parseSort } from "@/lib/sorting";

export type ListingSource =
  | { kind: "collection"; handle: string }
  | { kind: "all"; productType?: string }
  | { kind: "search"; query: string };

const EMPTY: ProductPage = { products: [], pageInfo: { hasNextPage: false, endCursor: null } };

const short = (value: unknown, max = 200): value is string => typeof value === "string" && value.length <= max;

// Next page of a listing, for the "Show more" button.
export async function loadMoreProducts(source: ListingSource, sort: unknown, after: unknown): Promise<ProductPage> {
  if (!short(after, 500) || typeof source !== "object" || source === null) return EMPTY;
  const sortSlug = parseSort(short(sort) ? sort : undefined);

  switch (source.kind) {
    case "collection":
      if (!short(source.handle)) return EMPTY;
      return (await getCollectionProducts({ handle: source.handle, sort: sortSlug, after })) ?? EMPTY;
    case "all":
      return getProducts({ productType: short(source.productType) ? source.productType : undefined, sort: sortSlug, after });
    case "search":
      if (!short(source.query)) return EMPTY;
      return getProducts({ search: source.query, sort: sortSlug, after });
    default:
      return EMPTY;
  }
}
